import { render } from "./Admin.vue?vue&type=template&id=50153274&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=50153274&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Asus\\Desktop\\vue\\akpa\\akpa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50153274"]])

export default __exports__